<template>
  <div class="fullscreen-spin" v-if="exporting">
    <div class="spin-content">
      <img src="../assets/images/export.png" />
      <p>
        正在合成{{
          exportType === "pptx" ? "PPTX" : exportType === "pdf" ? "PDF" : "图片"
        }}文件 ...
      </p>
      <Spin size="large" />
      <button @click="cancelExport" style="color: #0358f4; margin: 20px 0 0 0">
        取消
      </button>
    </div>
    <div class="spin-bg"></div>
  </div>
</template>

<script lang="ts">
import { MutationTypes, store } from "@/store";
import { computed, defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "fullscreen-spin",
  props: {
    exportType: {
      type: String,
      default: "",
    },
  },
  setup() {
    const percent = ref(0);
    const exporting = computed(() => store.state.exporting);
    const cancelExport = () => {
      store.commit(MutationTypes.SET_EXPORTING_STATE, false);
      location.reload();
    };
    return {
      percent,
      exporting,
      cancelExport,
    };
  },
});
</script>

<style lang="scss" scoped>
.fullscreen-spin {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;

  .spin-content {
    width: 430px;
    height: 350px;
    border-radius: 8px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -215px;
    margin-top: -200px;
    z-index: 11;
    padding: 50px 100px;
    text-align: center;
    p {
      padding: 15px 0 30px 0;
      font-size: 24px;
      color: #1c1c1c;
    }
    img {
      width: 100px;
    }
  }
  .spin-bg {
    z-index: 10;
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
  }
}
</style>
